import { computed, Injectable, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterService } from 'army-builder-shared';
import { BehaviorSubject, fromEvent, map, startWith } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ThemeService {
    theme$ = new BehaviorSubject('');
    theme = signal('');

    windowSize = toSignal(
        fromEvent(window, 'resize').pipe(
            startWith(window.innerWidth),
            map(() => window.innerWidth)
        )
    );

    isDesktop = computed(() => {
        return this.windowSize() > 991;
    });

    constructor(private routerService: RouterService) {}

    selectTheme(name: string) {
        this.theme$.next(name);
        this.theme.set(name);
    }
}
